var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',{staticClass:"tb-form-field",attrs:{"config":_vm.dp_config},on:{"dp-change":function (ev) {
        _vm.dateTimeChanged(ev.date);   
    }},model:{value:(_vm.dp_datetime),callback:function ($$v) {_vm.dp_datetime=$$v},expression:"dp_datetime"}})}
var staticRenderFns = []

export { render, staticRenderFns }